import { IVisitedOffersProviderProps, VisitedOffersProvider } from '@cian/frontend-visited-offers-widget';
import { Experiment } from '@cian/experiments/ab';
import { useSelector } from 'react-redux';
import * as React from 'react';

import { RecommendationsListContainer } from '../RecommendationsListContainer';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectUser } from '../../selectors';
import { selectActiveTab } from '../../selectors/activeTab';
import { ETabType } from '../../types/filters';
import { PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT } from '../../constants/experiments';

export const RecommendationsContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const { isAuthenticated } = useSelector(selectUser);
  const { activeTab } = useSelector(selectActiveTab);

  const isAdvertisementsTab = activeTab !== ETabType.JK && activeTab !== ETabType.SavedSearches;

  const { settings, enabled } = config.get<IVisitedOffersProviderProps>('audience.visitedOffers') || {};

  if (!isAuthenticated || !isAdvertisementsTab) {
    return null;
  }

  return (
    <Experiment name={PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT} group="B">
      <VisitedOffersProvider settings={settings} enabled={enabled}>
        <RecommendationsListContainer />
      </VisitedOffersProvider>
    </Experiment>
  );
};
